module.exports = __webpack_public_path__ + "static/media/1-1.73041bbc.png";